<template>
    <!--begin::Card-->
    <div class="card" :key="key">
        <!--begin::Card header-->
        <div class="card-header border-0">
            <!--begin::Card title-->
            <div class="card-title" v-if="currentUser.rol === 'ADMINISTRADOR'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="19"
                    viewBox="0 0 28 28"
                    fill="none"
                    style="margin-right: 17px"
                >
                    <path
                        d="M6.2223 6.37793H18.6667V7.62237H6.2223V6.37793ZM6.2223 12.6002H12.5114V13.8446H6.2223V12.6002ZM18.183 9.48904H6.2223V10.7335H16.9393L18.183 9.48904ZM9.95019 22.6117C10.1594 22.8516 10.4249 23.0358 10.7229 23.1476C11.0209 23.2595 11.342 23.2956 11.6574 23.2526H17.7264C17.8708 23.2526 18.0093 23.1952 18.1114 23.0931C18.2135 22.991 18.2709 22.8525 18.2709 22.7081C18.2709 22.5638 18.2135 22.4253 18.1114 22.3232C18.0093 22.2211 17.8708 22.1637 17.7264 22.1637H11.6574C10.9489 22.1513 11.0749 21.536 11.1744 21.3455C11.3042 21.1218 11.4053 20.8827 11.4754 20.6338C11.5219 20.4335 11.5 20.2235 11.4132 20.0371C11.3263 19.8507 11.1796 19.6988 10.9963 19.6056C10.7019 19.4729 10.3721 19.4404 10.0574 19.5131C9.74277 19.5857 9.46058 19.7594 9.25407 20.0077C8.98652 20.2838 8.61474 20.7062 8.25852 21.1168C8.47863 20.2543 8.76407 19.1475 9.04407 18.0679C9.12431 17.8219 9.10834 17.5547 8.99937 17.32C8.8904 17.0853 8.69655 16.9007 8.45685 16.8033C8.19141 16.7122 7.90129 16.7252 7.64506 16.8397C7.38883 16.9541 7.18557 17.1616 7.0763 17.42C6.7403 18.0664 4.0803 22.5238 4.05385 22.5689C4.01718 22.6303 3.99297 22.6983 3.98258 22.7691C3.9722 22.8398 3.97585 22.9119 3.99332 22.9812C4.0108 23.0506 4.04177 23.1158 4.08445 23.1732C4.12713 23.2305 4.18069 23.2789 4.24207 23.3156C4.36605 23.3897 4.51436 23.4114 4.65439 23.3761C4.79442 23.3408 4.91469 23.2513 4.98874 23.1274C5.0883 22.9602 7.21163 19.4034 7.8813 18.2157C7.3773 20.1602 6.82196 22.3239 6.7893 22.5184C6.75252 22.6613 6.76356 22.8124 6.82072 22.9485C6.87789 23.0846 6.97803 23.1982 7.10585 23.272C7.24823 23.3426 7.41005 23.3639 7.56581 23.3323C7.72157 23.3008 7.86239 23.2183 7.96607 23.0978C8.06407 23.0092 8.24763 22.7984 8.71041 22.2609C9.14158 21.7538 9.5832 21.2557 10.035 20.7668C10.2045 20.5879 10.3072 20.6673 10.2076 20.843C10.0129 21.0891 9.88659 21.3823 9.84152 21.6929C9.79645 22.0034 9.83343 22.3204 9.95019 22.6117Z"
                        fill="#006C90"
                    />
                    <path
                        d="M21.7779 16.874V24.889H3.11122V3.11122H21.7779V6.99466L22.8123 5.96022C22.9716 5.80316 23.1461 5.66246 23.3334 5.54022V2.33344C23.3334 2.12716 23.2515 1.92933 23.1056 1.78347C22.9598 1.63761 22.7619 1.55566 22.5557 1.55566H2.33344C2.12716 1.55566 1.92933 1.63761 1.78347 1.78347C1.63761 1.92933 1.55566 2.12716 1.55566 2.33344V25.6668C1.55566 25.8731 1.63761 26.0709 1.78347 26.2167C1.92933 26.3626 2.12716 26.4446 2.33344 26.4446H22.5557C22.7619 26.4446 22.9598 26.3626 23.1056 26.2167C23.2515 26.0709 23.3334 25.8731 23.3334 25.6668V16.6656C22.8564 16.9183 22.3047 16.9923 21.7779 16.874Z"
                        fill="#006C90"
                    />
                    <path
                        d="M26.5439 9.22508L26.1371 8.8183C26.345 8.54356 26.4503 8.20475 26.4346 7.86057C26.419 7.51639 26.2835 7.18852 26.0516 6.93374C25.7505 6.66839 25.3568 6.53275 24.9562 6.55635C24.5556 6.57995 24.1805 6.76088 23.9127 7.05974L14.171 16.7999L13.52 19.2436C13.5097 19.2756 13.5084 19.3098 13.5164 19.3425C13.5243 19.3751 13.5411 19.4049 13.565 19.4286C13.5888 19.4523 13.6187 19.4689 13.6514 19.4766C13.6841 19.4843 13.7183 19.4828 13.7502 19.4723L16.1854 18.8135L25.2792 9.71974L25.6634 10.1047C25.6903 10.1315 25.7116 10.1634 25.7261 10.1984C25.7406 10.2334 25.7481 10.271 25.7481 10.3089C25.7481 10.3468 25.7406 10.3844 25.7261 10.4194C25.7116 10.4545 25.6903 10.4863 25.6634 10.5131L21.8391 14.3374C21.7225 14.4542 21.657 14.6125 21.657 14.7775C21.6571 14.9426 21.7227 15.1008 21.8395 15.2175C21.9563 15.3341 22.1146 15.3996 22.2796 15.3995C22.4447 15.3995 22.6029 15.3338 22.7196 15.2171L26.5439 11.3927C26.8313 11.1051 26.9928 10.7151 26.9928 10.3085C26.9928 9.90189 26.8313 9.51191 26.5439 9.2243V9.22508Z"
                        fill="#006C90"
                    />
                </svg>
                Licitaciones
            </div>
            <div class="card-title" v-if="currentUser.rol !== 'ADMINISTRADOR'">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="23"
                    height="19"
                    viewBox="0 0 28 28"
                    fill="none"
                    style="margin-right: 17px"
                >
                    <path
                        d="M6.2223 6.37793H18.6667V7.62237H6.2223V6.37793ZM6.2223 12.6002H12.5114V13.8446H6.2223V12.6002ZM18.183 9.48904H6.2223V10.7335H16.9393L18.183 9.48904ZM9.95019 22.6117C10.1594 22.8516 10.4249 23.0358 10.7229 23.1476C11.0209 23.2595 11.342 23.2956 11.6574 23.2526H17.7264C17.8708 23.2526 18.0093 23.1952 18.1114 23.0931C18.2135 22.991 18.2709 22.8525 18.2709 22.7081C18.2709 22.5638 18.2135 22.4253 18.1114 22.3232C18.0093 22.2211 17.8708 22.1637 17.7264 22.1637H11.6574C10.9489 22.1513 11.0749 21.536 11.1744 21.3455C11.3042 21.1218 11.4053 20.8827 11.4754 20.6338C11.5219 20.4335 11.5 20.2235 11.4132 20.0371C11.3263 19.8507 11.1796 19.6988 10.9963 19.6056C10.7019 19.4729 10.3721 19.4404 10.0574 19.5131C9.74277 19.5857 9.46058 19.7594 9.25407 20.0077C8.98652 20.2838 8.61474 20.7062 8.25852 21.1168C8.47863 20.2543 8.76407 19.1475 9.04407 18.0679C9.12431 17.8219 9.10834 17.5547 8.99937 17.32C8.8904 17.0853 8.69655 16.9007 8.45685 16.8033C8.19141 16.7122 7.90129 16.7252 7.64506 16.8397C7.38883 16.9541 7.18557 17.1616 7.0763 17.42C6.7403 18.0664 4.0803 22.5238 4.05385 22.5689C4.01718 22.6303 3.99297 22.6983 3.98258 22.7691C3.9722 22.8398 3.97585 22.9119 3.99332 22.9812C4.0108 23.0506 4.04177 23.1158 4.08445 23.1732C4.12713 23.2305 4.18069 23.2789 4.24207 23.3156C4.36605 23.3897 4.51436 23.4114 4.65439 23.3761C4.79442 23.3408 4.91469 23.2513 4.98874 23.1274C5.0883 22.9602 7.21163 19.4034 7.8813 18.2157C7.3773 20.1602 6.82196 22.3239 6.7893 22.5184C6.75252 22.6613 6.76356 22.8124 6.82072 22.9485C6.87789 23.0846 6.97803 23.1982 7.10585 23.272C7.24823 23.3426 7.41005 23.3639 7.56581 23.3323C7.72157 23.3008 7.86239 23.2183 7.96607 23.0978C8.06407 23.0092 8.24763 22.7984 8.71041 22.2609C9.14158 21.7538 9.5832 21.2557 10.035 20.7668C10.2045 20.5879 10.3072 20.6673 10.2076 20.843C10.0129 21.0891 9.88659 21.3823 9.84152 21.6929C9.79645 22.0034 9.83343 22.3204 9.95019 22.6117Z"
                        fill="#006C90"
                    />
                    <path
                        d="M21.7779 16.874V24.889H3.11122V3.11122H21.7779V6.99466L22.8123 5.96022C22.9716 5.80316 23.1461 5.66246 23.3334 5.54022V2.33344C23.3334 2.12716 23.2515 1.92933 23.1056 1.78347C22.9598 1.63761 22.7619 1.55566 22.5557 1.55566H2.33344C2.12716 1.55566 1.92933 1.63761 1.78347 1.78347C1.63761 1.92933 1.55566 2.12716 1.55566 2.33344V25.6668C1.55566 25.8731 1.63761 26.0709 1.78347 26.2167C1.92933 26.3626 2.12716 26.4446 2.33344 26.4446H22.5557C22.7619 26.4446 22.9598 26.3626 23.1056 26.2167C23.2515 26.0709 23.3334 25.8731 23.3334 25.6668V16.6656C22.8564 16.9183 22.3047 16.9923 21.7779 16.874Z"
                        fill="#006C90"
                    />
                    <path
                        d="M26.5439 9.22508L26.1371 8.8183C26.345 8.54356 26.4503 8.20475 26.4346 7.86057C26.419 7.51639 26.2835 7.18852 26.0516 6.93374C25.7505 6.66839 25.3568 6.53275 24.9562 6.55635C24.5556 6.57995 24.1805 6.76088 23.9127 7.05974L14.171 16.7999L13.52 19.2436C13.5097 19.2756 13.5084 19.3098 13.5164 19.3425C13.5243 19.3751 13.5411 19.4049 13.565 19.4286C13.5888 19.4523 13.6187 19.4689 13.6514 19.4766C13.6841 19.4843 13.7183 19.4828 13.7502 19.4723L16.1854 18.8135L25.2792 9.71974L25.6634 10.1047C25.6903 10.1315 25.7116 10.1634 25.7261 10.1984C25.7406 10.2334 25.7481 10.271 25.7481 10.3089C25.7481 10.3468 25.7406 10.3844 25.7261 10.4194C25.7116 10.4545 25.6903 10.4863 25.6634 10.5131L21.8391 14.3374C21.7225 14.4542 21.657 14.6125 21.657 14.7775C21.6571 14.9426 21.7227 15.1008 21.8395 15.2175C21.9563 15.3341 22.1146 15.3996 22.2796 15.3995C22.4447 15.3995 22.6029 15.3338 22.7196 15.2171L26.5439 11.3927C26.8313 11.1051 26.9928 10.7151 26.9928 10.3085C26.9928 9.90189 26.8313 9.51191 26.5439 9.2243V9.22508Z"
                        fill="#006C90"
                    />
                </svg>
                Mis Licitaciones
            </div>
            <!--begin::Card title-->
        </div>
        <!--end::Card header-->

        <!--begin: Card-body Drag and Drop-->
        <div class="card-body col-12">
            <div id="card-filter" class="col-12 row">
                <div class="col-12 col-md-6 col-xl-4 col-xxl-4">
                    <label for="nombreLicitacion" class="col-12">Nombre</label>
                    <input
                        type="text"
                        id="nombreLicitacion"
                        v-model="nombreLicitacion"
                        class="col-12 form-control"
                    />
                </div>
                <div class="col-12 col-md-6 col-xl-2 col-xxl-2">
                    <label for="fechaDesde" class="col-12">Fecha Desde</label>
                    <input
                        type="date"
                        id="fechaDesde"
                        v-model="fechaDesde"
                        class="col-12 form-control"
                    />
                </div>
                <div class="col-12 col-md-6 col-xl-2 col-xxl-2">
                    <label for="fechaHasta" class="col-12">Fecha Hasta</label>
                    <input
                        type="date"
                        id="fechaHasta"
                        v-model="fechaHasta"
                        class="col-12 form-control"
                    />
                </div>
                <div class="buttons-filter col-12 col-xl-4 col-xxl-4">
                    <div class="col-12 col-md-6">
                        <button
                            class="btn btn-melon col-12"
                            @click="filtrarItems"
                        >
                            Filtrar
                        </button>
                    </div>
                    <div class="col-12 col-md-6">
                        <button class="btn btn-melon-secundario col-12" @click="limpiar">
                            Limpiar
                        </button>
                    </div>
                </div>
            </div>
            <div
                id="botonera"
                class="col-12"
                v-if="currentUser.rol === 'ADMINISTRADOR'"
            >
                <div id="button-eliminar">
                    <button
                        v-if="!selectEliminar"
                        style="background-color: #99c4d3; border-color: #99c4d3"
                        class="btn btn-melon-secundario"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            style="margin-right: 7px"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M6.25 3V1.5H10.75V3H6.25ZM4.75 3V1C4.75 0.734784 4.85536 0.48043 5.04289 0.292893C5.23043 0.105357 5.48478 0 5.75 0L11.25 0C11.5152 0 11.7696 0.105357 11.9571 0.292893C12.1446 0.48043 12.25 0.734784 12.25 1V3H14.75C14.9489 3 15.1397 3.07902 15.2803 3.21967C15.421 3.36032 15.5 3.55109 15.5 3.75C15.5 3.94891 15.421 4.13968 15.2803 4.28033C15.1397 4.42098 14.9489 4.5 14.75 4.5H14.385L13.642 14.153C13.6034 14.6554 13.3767 15.1248 13.007 15.4673C12.6373 15.8097 12.1519 16 11.648 16H5.352C4.84808 16 4.36274 15.8097 3.99304 15.4673C3.62335 15.1248 3.39655 14.6554 3.358 14.153L2.615 4.5H2.25C2.05109 4.5 1.86032 4.42098 1.71967 4.28033C1.57902 4.13968 1.5 3.94891 1.5 3.75C1.5 3.55109 1.57902 3.36032 1.71967 3.21967C1.86032 3.07902 2.05109 3 2.25 3H4.75ZM4.12 4.5H12.88L12.146 14.038C12.1364 14.1636 12.0798 14.2809 11.9875 14.3666C11.8952 14.4522 11.7739 14.4999 11.648 14.5H5.352C5.22607 14.4999 5.10482 14.4522 5.0125 14.3666C4.92017 14.2809 4.86357 14.1636 4.854 14.038L4.12 4.5Z"
                                fill="white"
                            />
                        </svg>
                        Eliminar
                    </button>
                    <button @click="eliminarFilas" v-if="selectEliminar" class="btn btn-melon-secundario">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            style="margin-right: 7px"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M6.25 3V1.5H10.75V3H6.25ZM4.75 3V1C4.75 0.734784 4.85536 0.48043 5.04289 0.292893C5.23043 0.105357 5.48478 0 5.75 0L11.25 0C11.5152 0 11.7696 0.105357 11.9571 0.292893C12.1446 0.48043 12.25 0.734784 12.25 1V3H14.75C14.9489 3 15.1397 3.07902 15.2803 3.21967C15.421 3.36032 15.5 3.55109 15.5 3.75C15.5 3.94891 15.421 4.13968 15.2803 4.28033C15.1397 4.42098 14.9489 4.5 14.75 4.5H14.385L13.642 14.153C13.6034 14.6554 13.3767 15.1248 13.007 15.4673C12.6373 15.8097 12.1519 16 11.648 16H5.352C4.84808 16 4.36274 15.8097 3.99304 15.4673C3.62335 15.1248 3.39655 14.6554 3.358 14.153L2.615 4.5H2.25C2.05109 4.5 1.86032 4.42098 1.71967 4.28033C1.57902 4.13968 1.5 3.94891 1.5 3.75C1.5 3.55109 1.57902 3.36032 1.71967 3.21967C1.86032 3.07902 2.05109 3 2.25 3H4.75ZM4.12 4.5H12.88L12.146 14.038C12.1364 14.1636 12.0798 14.2809 11.9875 14.3666C11.8952 14.4522 11.7739 14.4999 11.648 14.5H5.352C5.22607 14.4999 5.10482 14.4522 5.0125 14.3666C4.92017 14.2809 4.86357 14.1636 4.854 14.038L4.12 4.5Z"
                                fill="white"
                            />
                        </svg>
                        Eliminar
                    </button>
                </div>
                <div id="button-nuevo">
                    <button @click="nuevaLicitacion = true" class="btn btn-melon">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style="margin-right: 7px"
                        >
                            <path
                                d="M3.99993 4.1001H11.9999V4.9001H3.99993V4.1001ZM3.99993 8.1001H8.04293V8.9001H3.99993V8.1001ZM11.6889 6.1001H3.99993V6.9001H10.8894L11.6889 6.1001ZM6.39643 14.5361C6.53091 14.6903 6.70161 14.8087 6.89318 14.8806C7.08474 14.9525 7.29118 14.9757 7.49393 14.9481H11.3954C11.4883 14.9481 11.5773 14.9112 11.6429 14.8456C11.7086 14.7799 11.7454 14.6909 11.7454 14.5981C11.7454 14.5053 11.7086 14.4162 11.6429 14.3506C11.5773 14.285 11.4883 14.2481 11.3954 14.2481H7.49393C7.03843 14.2401 7.11943 13.8446 7.18343 13.7221C7.26687 13.5783 7.33188 13.4246 7.37693 13.2646C7.40682 13.1358 7.39273 13.0008 7.33691 12.881C7.28108 12.7612 7.18674 12.6635 7.06893 12.6036C6.87965 12.5183 6.66765 12.4974 6.46537 12.5441C6.26309 12.5908 6.08168 12.7025 5.94893 12.8621C5.77693 13.0396 5.53793 13.3111 5.30893 13.5751C5.45043 13.0206 5.63393 12.3091 5.81393 11.6151C5.86551 11.457 5.85524 11.2852 5.78519 11.1343C5.71514 10.9834 5.59051 10.8647 5.43643 10.8021C5.26578 10.7435 5.07928 10.7519 4.91456 10.8255C4.74984 10.8991 4.61917 11.0324 4.54893 11.1986C4.33293 11.6141 2.62293 14.4796 2.60593 14.5086C2.58235 14.5481 2.56678 14.5918 2.56011 14.6373C2.55343 14.6827 2.55578 14.7291 2.56701 14.7737C2.57825 14.8182 2.59816 14.8602 2.62559 14.897C2.65303 14.9339 2.68746 14.965 2.72693 14.9886C2.80662 15.0362 2.90197 15.0502 2.99199 15.0275C3.082 15.0048 3.15932 14.9473 3.20693 14.8676C3.27093 14.7601 4.63593 12.4736 5.06643 11.7101C4.74243 12.9601 4.38543 14.3511 4.36443 14.4761C4.34079 14.568 4.34788 14.6651 4.38463 14.7526C4.42138 14.8401 4.48575 14.9131 4.56793 14.9606C4.65945 15.006 4.76348 15.0196 4.86361 14.9993C4.96374 14.9791 5.05427 14.926 5.12093 14.8486C5.18393 14.7916 5.30193 14.6561 5.59943 14.3106C5.87661 13.9846 6.1605 13.6644 6.45093 13.3501C6.55993 13.2351 6.62593 13.2861 6.56193 13.3991C6.43673 13.5573 6.35555 13.7458 6.32657 13.9454C6.2976 14.1451 6.32137 14.3488 6.39643 14.5361Z"
                                fill="white"
                            />
                            <path
                                d="M14 10.8475V16H2V2H14V4.4965L14.665 3.8315C14.7674 3.73054 14.8796 3.64008 15 3.5615V1.5C15 1.36739 14.9473 1.24021 14.8536 1.14645C14.7598 1.05268 14.6326 1 14.5 1H1.5C1.36739 1 1.24021 1.05268 1.14645 1.14645C1.05268 1.24021 1 1.36739 1 1.5V16.5C1 16.6326 1.05268 16.7598 1.14645 16.8536C1.24021 16.9473 1.36739 17 1.5 17H14.5C14.6326 17 14.7598 16.9473 14.8536 16.8536C14.9473 16.7598 15 16.6326 15 16.5V10.7135C14.6933 10.876 14.3386 10.9235 14 10.8475Z"
                                fill="white"
                            />
                            <path
                                d="M17.0639 5.93068L16.8024 5.66919C16.9361 5.49257 17.0037 5.27476 16.9937 5.0535C16.9837 4.83224 16.8965 4.62147 16.7474 4.45768C16.5539 4.2871 16.3008 4.1999 16.0433 4.21507C15.7857 4.23024 15.5446 4.34656 15.3724 4.53868L9.10993 10.8002L8.69143 12.3712C8.68481 12.3917 8.684 12.4137 8.6891 12.4347C8.69421 12.4557 8.70502 12.4749 8.72034 12.4901C8.73566 12.5053 8.7549 12.516 8.77592 12.5209C8.79694 12.5259 8.81892 12.5249 8.83943 12.5182L10.4049 12.0947L16.2509 6.24868L16.4979 6.49618C16.5152 6.51341 16.5289 6.53387 16.5382 6.55639C16.5475 6.57891 16.5523 6.60306 16.5523 6.62743C16.5523 6.65181 16.5475 6.67596 16.5382 6.69848C16.5289 6.721 16.5152 6.74146 16.4979 6.75868L14.0394 9.21719C13.9644 9.29224 13.9223 9.39401 13.9224 9.50011C13.9224 9.60621 13.9646 9.70795 14.0397 9.78294C14.1147 9.85793 14.2165 9.90003 14.3226 9.89998C14.4287 9.89993 14.5304 9.85774 14.6054 9.78269L17.0639 7.32418C17.2487 7.13929 17.3525 6.88859 17.3525 6.62718C17.3525 6.36578 17.2487 6.11508 17.0639 5.93018V5.93068Z"
                                fill="white"
                            />
                        </svg>
                        Crear Licitaciones
                    </button>
                </div>
            </div>
            <div class="contenedor-table mt-5">
                <DataTable
                    :value="items"
                    :paginator="true"
                    :rows="10"
                    showGridlines
                    dataKey="id"
                    :rowHover="true"
                    v-model:selection="selectedCustomers"
                    :loading="loading"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[10, 25, 50]"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                    :globalFilterFields="['nombre', 'fechaTermino']"
                    responsiveLayout="stack"
                    breakpoint="960px"
                    class="tabla-melon"
                    v-if="false"
                >
                    <template #empty> No existen documentos. </template>
                    <template #loading>
                        Cargando sus documentos. Por favor espere.
                    </template>

                    <Column
                        field="codigo"
                        header="Id"
                        sortable
                        style="min-width: 9rem"
                    >
                        <template #body="{ data }">
                            {{ data.codigo }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                placeholder="Search by name"
                            />
                        </template>
                    </Column>
                    <Column
                        field="nombreLicitacion"
                        header="Nombre Licitacion"
                        sortable
                        filterMatchMode="contains"
                        style="min-width: 14rem"
                    >
                        <template #body="{ data }">
                            {{ data.nombreLicitacion }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                placeholder="Search by country"
                            />
                        </template>
                    </Column>

                    <Column
                        field="ubicacion"
                        header="Ubicación"
                        sortable
                        filterMatchMode="contains"
                        style="min-width: 14rem"
                    >
                        <template #body="{ data }">
                            {{ data.ubicacion }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                placeholder="Search by country"
                            />
                        </template>
                    </Column>

                    <Column
                        field="fechaLimite"
                        header="Fecha Limite"
                        sortable
                        dataType="date"
                        style="min-width: 8rem"
                    >
                        <template #body="{ data }">
                            {{ data.fechaLimite }}
                        </template>
                        <template #filter="{ filterModel }">
                            <Calendar
                                v-model="filterModel.value"
                                dateFormat="mm/dd/yy"
                                placeholder="mm/dd/yyyy"
                            />
                        </template>
                    </Column>

                    <Column
                        field="estado"
                        header="Estado"
                        sortable
                        filterMatchMode="contains"
                        style="min-width: 14rem"
                    >
                        <template #body="{ data }">
                            {{ data.estado }}
                        </template>
                        <template #filter="{ filterModel }">
                            <InputText
                                type="text"
                                v-model="filterModel.value"
                                class="p-column-filter"
                                placeholder="Search by country"
                            />
                        </template>
                    </Column>
                </DataTable>

                <table class="table table-striped mb-10" v-if="true">
                    <thead class="thead-document">
                        <tr>
                            <th
                                scope="col col-2"
                                class="th-1 th-1-1"
                                v-if="currentUser.rol === 'ADMINISTRADOR'"
                            >
                                <input
                                    type="checkbox"
                                    id="header-checkbox"
                                    v-model="selectAll"
                                />
                            </th>
                            <!-- <th
                                scope="col"
                                class="th-1 th-1-1"
                                v-if="currentUser.rol !== 'ADMINISTRADOR'"
                            >
                                Id
                            </th>
                            <th
                                scope="col"
                                class="th-1"
                                v-if="currentUser.rol === 'ADMINISTRADOR'"
                            >
                                Id
                            </th> -->
                            <th scope="col" class="th-1">
                                Nombre de la Licitacion
                            </th>
                            <th
                                scope="col"
                                class="th-1"
                                v-if="currentUser.rol === 'ADMINISTRADOR'"
                            >
                                Fecha Publicación
                            </th>
                            <th
                                scope="col"
                                class="th-1"
                                v-if="currentUser.rol !== 'ADMINISTRADOR'"
                            >
                                Ubicación
                            </th>
                            <th scope="col" class="th-1">Fecha Limite</th>
                            <th
                                scope="col"
                                class="th-1"
                                v-if="currentUser.rol !== 'ADMINISTRADOR'"
                            >
                                Estado
                            </th>
                            <th scope="col" class="th-1 th-5-1"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <th
                                scope="col"
                                class="th-1-1"
                                v-if="
                                    item.Activo &&
                                    currentUser.rol === 'ADMINISTRADOR'
                                "
                            >
                                <input
                                    type="checkbox"
                                    :id="'checkbox' + index"
                                    v-model="item.selected"
                                    @click="EliminarBox(!item.selected)"
                                />
                            </th>
                            <!-- <th
                                scope="col"
                                v-if="
                                    item.Activo &&
                                    currentUser.rol === 'ADMINISTRADOR'
                                "
                            >
                                {{ item.id }}
                            </th> -->
                            <!-- <th
                                scope="col"
                                class="th-1-1"
                                v-if="
                                    item.Activo &&
                                    currentUser.rol !== 'ADMINISTRADOR'
                                "
                            >
                                {{ item.id }}
                            </th> -->
                            <th scope="col" v-if="item.Activo">
                                {{ item.nombreLicitacion }}
                            </th>
                            <th
                                scope="col"
                                v-if="
                                    item.Activo &&
                                    currentUser.rol === 'ADMINISTRADOR'
                                "
                            >
                                {{ item.fechaPublicacion }}
                            </th>
                            <th
                                scope="col"
                                style="
                                    max-width: 270px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                "
                                v-if="
                                    item.Activo &&
                                    currentUser.rol !== 'ADMINISTRADOR'
                                "
                            >
                                {{ item.ubicacion }}
                            </th>
                            <th scope="col" v-if="item.Activo">
                                {{ item.fechaLimite }}
                            </th>
                            <th
                                scope="col"
                                v-if="
                                    item.Activo &&
                                    currentUser.rol !== 'ADMINISTRADOR'
                                "
                            >
                                {{ item.estado }}
                            </th>
                            <th
                                v-if="
                                    item.Activo &&
                                    currentUser.rol !== 'ADMINISTRADOR' &&
                                    item.estado !== 'ENRE'
                                "
                            ></th>
                            <th
                                scope="col"
                                style="
                                    cursor: pointer;
                                    position: relative;
                                    height: 50px !important;
                                "
                                @click="CargarDocumento(index)"
                                v-if="
                                    item.Activo &&
                                    currentUser.rol !== 'ADMINISTRADOR' &&
                                    item.estado == 'ENRE'
                                "
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        fill="#006c90"
                                        d="M11 16V7.85l-2.6 2.6L7 9l5-5l5 5l-1.4 1.45l-2.6-2.6V16h-2Zm-5 4q-.825 0-1.413-.588T4 18v-3h2v3h12v-3h2v3q0 .825-.588 1.413T18 20H6Z"
                                    />
                                </svg>
                            </th>
                            <th
                                scope="col"
                                style="cursor: pointer; position: relative"
                                @click="mostrarEdit(index)"
                                v-if="
                                    item.Activo &&
                                    currentUser.rol === 'ADMINISTRADOR'
                                "
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="7"
                                    viewBox="0 0 27 8"
                                    fill="none"
                                >
                                    <path
                                        d="M19.5 4C19.5 5.933 21.067 7.5 23 7.5C24.933 7.5 26.5 5.933 26.5 4C26.5 2.067 24.933 0.5 23 0.5C21.067 0.5 19.5 2.067 19.5 4Z"
                                        fill="#99ABB4"
                                    />
                                    <path
                                        d="M10.1667 4C10.1667 5.933 11.7338 7.5 13.6667 7.5C15.5997 7.5 17.1667 5.933 17.1667 4C17.1667 2.067 15.5997 0.5 13.6667 0.5C11.7338 0.5 10.1667 2.067 10.1667 4Z"
                                        fill="#99ABB4"
                                    />
                                    <path
                                        d="M0.5 4C0.5 5.933 2.067 7.5 4 7.5C5.933 7.5 7.5 5.933 7.5 4C7.5 2.067 5.933 0.5 4 0.5C2.067 0.5 0.5 2.067 0.5 4Z"
                                        fill="#99ABB4"
                                    />
                                </svg>
                                <div v-if="item.edit" class="editar-box">
                                    <ul>
                                        <li @click="editLicitacion(
                                                item.id,
                                                item.nombreLicitacion,
                                                item.fechaPublicacion,
                                                item.fechaLimite,
                                                item.codigo,
                                                item.ubicacion
                                            )">
                                            Editar Licitación
                                        </li>
                                         <li
                                        class=""
                                        @click="veLicitantes(item.id)"
                                    >
                                        Ver Licitantes
                                    </li>
                                    </ul>
                                </div>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!--end: Drag and Drop-->

            <!--Modal Exito-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalExito">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p class="modal-title" id="exampleModalLabel">
                                   Felicitaciones!!!
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalExito = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>{{ mensajeExito }}</p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-melon"
                                    @click="showModalExito = false"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <!--Modal Error-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalError">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p
                                    class="modal-title header-error"
                                    id="exampleModalLabel"
                                >
                                    ERROR
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalError = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>{{ mensajeError }}</p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn btn-melon"
                                    @click="showModalError = false"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <!--end: Drag and Drop-->
        </div>
        <!--end::Card body-->
        <Loading v-if="loading || carga"></Loading>
        <NewLicitacion
            v-if="nuevaLicitacion"
            @cancelar="nuevaLicitacion = false"
            @guardar="guardar"
        ></NewLicitacion>
        <EditLicitacion
            v-if="editarLicitacion"
            @cancelar="editarLicitacion = false"
            @editar="editar"
            :NombreLicitacion="nombreLicitacion"
            :FechaPublicacion="fechaPublicacion"
            :FechaLimite="fechaLimite"
            :Ubicacion="ubicacion"
            :Codigo="codigo"
        ></EditLicitacion>
    </div>
    <!--end::Card-->
</template>

<script>
import { Actions } from "@/store/enums/StoreEnums";
import { computed } from "vue";
import { ref,nextTick } from "vue";
import { useStore } from "vuex";
import EditLicitacion from "@/components/licitaciones/editLicitacion.vue";
import Loading from "@/components/Loading.vue";
import NewLicitacion from "@/components/licitaciones/newLicitacion.vue";
import router from "@/router";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode, FilterOperator } from "primevue/api";
export default {
    name: "Licitaciones",
    components: {
        Loading,
        NewLicitacion,
        EditLicitacion,
        DataTable,
        Column,
    },
    setup() {
        const store = useStore();
        const selectAll = ref(false);
        const items = ref([]);
        const result = ref([]);
        const selectedCustomers = ref([]);
        const key = ref(0);

        var carga = ref(true);

        const currentUser = computed(() => {
            return store.getters.currentUser;
        });
        const formatDate = (value) => {
            if (value == null) return "";
            value = new Date(value);
            return value.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        };

        const filters1 = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            numeroFactura: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                ],
            },
            nombreEmpresa: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                ],
            },
            detalleEstado: { value: null, matchMode: FilterMatchMode.IN },
            date: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.DATE_IS },
                ],
            },
            balance: {
                operator: FilterOperator.AND,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.EQUALS },
                ],
            },
            status: {
                operator: FilterOperator.OR,
                constraints: [
                    { value: null, matchMode: FilterMatchMode.EQUALS },
                ],
            },
            activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
            verified: { value: null, matchMode: FilterMatchMode.EQUALS },
        });

        const cargarItems = async () => {
            try {
                var data = {};
                if (currentUser.value.rol == "ADMINISTRADOR") {
                    data = await store.dispatch(Actions.GET_LICITACIONES);
                } else {
                    data = await store.dispatch(
                        Actions.GET_LICITACIONES_LICITANTE,
                        currentUser.value.id
                    );
                }
                const documentos = [];
                data.licitacions.forEach((item) => {
                    documentos.push({
                        id: item.codigo,
                        nombreLicitacion: item.nombre,
                        fechaLimite: formatearFecha(item.fechaTermino),
                        fechaPublicacion: formatearFecha(item.fechaPublicacion),
                        ubicacion: item.ubicacion,
                        codigo: item.codigo,
                        selected: false,
                        Activo: item.activo,
                        idLicitacion: "",
                        nombre: "",
                        edit: false,
                        estado: item.estadoLicitante,
                    });
                });
                const result = documentos.map((proxy) => ({ ...proxy }));
                // Asigna result a la variable items

                items.value = result;
            } catch (error) {
                console.error(error);
            }
        };

        const fetchItems = async () => {
            try {
                const documentos = [];
                var data = {};
                if (currentUser.value.rol == "ADMINISTRADOR") {
                    data = await store.dispatch(Actions.GET_LICITACIONES);
                } else {
                    data = await store.dispatch(
                        Actions.GET_LICITACIONES_LICITANTE,
                        currentUser.value.id
                    );
                }
                data.licitacions.forEach((item) => {
                    documentos.push({
                        id: item.codigo,
                        nombreLicitacion: item.nombre,
                        fechaLimite: item.fechaTermino,
                        fechaPublicacion: item.fechaPublicacion,
                        codigo: item.codigo,
                        selected: false,
                        Activo: item.activo,
                        idLicitacion: "",
                        nombre: "",
                        ubicacion: item.ubicacion,
                        edit: false,
                        estado: item.estadoLicitante,
                    });
                });
                result.value = documentos;
                // Llama a cargarItems para cargar los datos en items
                await cargarItems();
                carga.value = false;
            } catch (error) {
                console.error(error);
                carga.value = false;
            }
        };

        const formatearFecha = (fecha) => {
            const fechaFormato = new Date(fecha);
            var dia = fechaFormato.getDate();
            var mes = fechaFormato.getMonth() + 1; // Los meses en JavaScript son indexados desde 0
            var anio = fechaFormato.getFullYear();

            // Formatear la cadena en el nuevo formato
            return `${dia < 10 ? "0" : ""}${dia}/${
                mes < 10 ? "0" : ""
            }${mes}/${anio}`;
        };

        fetchItems();

        return {
            selectAll,
            items,
            result,
            carga,
            currentUser,
            cargarItems,
            formatearFecha,
            formatDate,
            filters1,
            selectedCustomers,
            key
        };
    },
    data() {
        return {
            fechaDesde: null,
            fechaHasta: null,
            id: null,
            nombreLicitacion: null,
            fechaPublicacion: null,
            fechaLimite: null,
            codigo: null,
            ubicacion: null,
            store: useStore(),
            loading: false,
            showModalExito: false,
            showModalError: false,
            mensajeError: "",
            mensajeExito: "",
            selectEliminar: false,
            nuevaLicitacion: false,
            editarLicitacion: false,
        };
    },
    methods: {
        async eliminarFilas() {
            const deleteList = [];
            this.loading = true;
            try {
                this.items.forEach(async (item) => {
                    if (item.selected) {
                        item.Activo = false;
                        deleteList.push(item.id);
                    }
                });
                var formData = new FormData();
                formData.append("values", JSON.stringify(deleteList));

                const data = await this.store.dispatch(
                    Actions.DELETE_LICITACIONES,
                    formData
                );
                this.mensajeExito =
                    "Las Licitaciones han sido eliminados exitosamente.";
                this.showModalExito = true;
                this.loading = false;
                await this.cargarItems();
            } catch (error) {
                this.loading = false;
                this.mensajeError = "Error al al intentar eliminar los grupos.";
                this.showModalError = true;
                console.log(error);
            }
            this.selectEliminar = false;
            //items.value = items.value.filter((item) => !item.selected);
        },
        cargarValoresIniciales() {
            this.items = this.result.map((proxy) => {
                return { ...proxy };
            });
        },

        filtrarItems() {
            this.cargarValoresIniciales();

            const fechaDesde = this.fechaDesde
                ? new Date(this.fechaDesde + "T00:00:00")
                : null;
            const fechaHasta = this.fechaHasta
                ? new Date(this.fechaHasta + "T23:59:59")
                : null;

            const nombreLicitacion =
                this.nombreLicitacion !== null ? this.nombreLicitacion : null;

            this.items = this.items.filter((item) => {
                const fechaPublicacion = new Date(
                    item.fechaPublicacion
                ).getTime();
                const nombreItem = item.nombreLicitacion;

                const fechaValida =
                    (!fechaDesde || fechaPublicacion >= fechaDesde) &&
                    (!fechaHasta || fechaPublicacion <= fechaHasta);

                const nombreCargaValido =
                    nombreLicitacion === null ||
                    nombreItem
                        .toUpperCase()
                        .includes(nombreLicitacion.toUpperCase());

                if (fechaValida && nombreCargaValido) {
                    item.fechaPublicacion = this.formatearFecha(
                        item.fechaPublicacion
                    );
                    item.fechaLimite = this.formatearFecha(item.fechaLimite);
                }

                return fechaValida && nombreCargaValido;
            });
        },
        Eliminar() {
            var aux = false;
            const values = this.items.map((proxy) => {
                return { ...proxy };
            });

            values.forEach((item) => {
                if (item.selected) {
                    aux = aux || true;
                }
            });
            this.selectEliminar = aux;
            return this.selectEliminar;
        },
        EliminarBox(check) {
            if (check) {
                this.selectEliminar = true;
            } else {
                var aux = 0;
                const values = this.items.map((proxy) => {
                    return { ...proxy };
                });

                values.forEach((item) => {
                    if (item.selected) {
                        aux += 1;
                    }
                });
                this.selectEliminar = aux <= 1 ? false : true;
            }
            return this.selectEliminar;
        },
        async guardar(files) {
            if (files == null) {
                this.mensajeError =
                    "No fue posible crear la licitación. Intenta nuevamente.";
                this.showModalError = true;
                this.nuevaLicitacion = false;
            } else {
                try {
                    const data = await this.store.dispatch(
                        Actions.GET_LICITACIONES
                    );
                    const documentos = [];
                    data.licitacions.forEach(async (item) => {
                        await documentos.push({
                            id: item.codigo,
                            nombreLicitacion: item.nombre,
                            fechaLimite: item.fechaTermino,
                            fechaPublicacion: item.fechaPublicacion,
                            codigo: item.codigo,
                            selected: false,
                            Activo: item.activo,
                            ubicacion: item.ubicacion,
                        });
                    });
                    const result = documentos.map((proxy) => ({ ...proxy }));

                    // Asigna result a la variable items
                    this.items = result;
                    await this.cargarItems();
                    this.mensajeExito =
                        "Se creo la licitación de manera correcta";
                    this.showModalExito = true;
                    this.nuevaLicitacion = false;

                    this.key += 1
                } catch (error) {
                    console.error(error);
                }
            }
        },
        async editar(files) {
            if (files == null) {
                this.mensajeError =
                    "No fue posible editar la licitación. Intenta nuevamente.";
                this.showModalError = true;
                this.editarLicitacion = false;
            } else {
                try {
                    const data = await this.store.dispatch(
                        Actions.GET_LICITACIONES
                    );
                    const documentos = [];
                    data.licitacions.forEach((item) => {
                        documentos.push({
                            id: item.codigo,
                            nombreLicitacion: item.nombre,
                            fechaLimite: item.fechaTermino,
                            fechaPublicacion: item.fechaPublicacion,
                            ubicacion: item.ubicacion,
                            codigo: item.codigo,
                            selected: false,
                            Activo: item.activo,
                            idLicitacion: "",
                            nombre: "",
                        });
                    });
                    const result = await documentos.map((proxy) => ({ ...proxy }));
                  this.nombreLicitacion = null
             this.fechaPublicacion = null
             this.fechaLimite = null
             this.codigo = null
            this.ubicacion = null
                    // Asigna result a la variable items
                    this.items = result;
                    await this.cargarItems();
                    this.mensajeExito =
                        "Se edito la licitación de manera correcta";
                    this.showModalExito = true;
                    this.editarLicitacion = false;
                   this.key += 1

   
                } catch (error) {
                    console.log(error);
                }
            }
        },
        infoLicitacion(id, nombre) {
            this.idLicitacion = id.toString();
            this.nombre = nombre.toString();
            this.verLicitacion = true;
        },

        async editLicitacion(id) {
            const obj = await this.result
                .filter((item) => item.id == id)
                .map((proxy) => {
                    return { ...proxy };
                })[0];
            this.nombreLicitacion = obj.nombreLicitacion.toString();
            this.fechaPublicacion = obj.fechaPublicacion;
            this.fechaLimite = obj.fechaLimite;
            this.codigo = obj.codigo.toString();
            this.ubicacion = obj.ubicacion.toString();
            this.editarLicitacion = true;
        },

        limpiar() {
            this.cargarValoresIniciales();
            this.items.forEach((item) => {
                item.fechaPublicacion = this.formatearFecha(
                    item.fechaPublicacion
                );
                item.fechaLimite = this.formatearFecha(item.fechaLimite);
            });
            this.nombreLicitacion = "";
            this.fechaDesde = "";
            this.fechaHasta = "";
        },
        mostrarEdit(index) {
            if (!this.items[index].edit) {
                this.items.forEach((item) => {
                    item.edit = false;
                });
            }
            this.items[index].edit = !this.items[index].edit;
        },
        veLicitantes(id) {
            router.push({ name: "apps-licitantes", params: { id: id } });
        },
    },
    watch: {
        selectAll: function (value) {
            this.items.forEach((item) => {
                item.selected = value;
            });
            this.Eliminar();
        },
    },
    computed: {},
};
</script>

<style scoped>


.button-edit {
    width: 100%;
    height: 30px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #fff;
    border-color: rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    color: #99abb4;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contenedor-table {
    overflow-x: auto;
    white-space: nowrap;
}

.carousel-control-prev,
.carousel-control-next {
    width: auto !important;
}

.btn-error {
    color: white;
    background-color: red;
}

.btn-guardar {
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.actions {
    width: 30px;
    height: 30px;
    background: #006c90;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    cursor: pointer;
}


.selectLicitacion {
    border-radius: 50px;
    border: 1px solid #cecece;
    background: #fff;
    width: 100%;
    height: 35px;
}

.btn-guardar {
    display: flex;
    width: 140px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.modal-footer {
    padding: 0px 1.5rem 1.5rem 0px !important;
    border: 0px !important;
}

#card-filter {
    background-color: #fff;
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    padding-top: 13px;
    padding-left: 18px;
    padding-bottom: 9px;
}

#card-filter label {
    color: #006c90;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}


.buttons-filter {
    justify-content: center;
    align-items: center;
    flex-direction: inherit !important;
}

.buttons-filter button {
    margin: 12px 0px;
    height: auto;
    min-height: 27px;
    padding: 5px 14px;
}

.button-filtrar {
    color: #fff;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
}

.button-limpiar {
    border-radius: 10px;
    background: #99abb4;
    color: #fff;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    border: 0px;
}

.card-body {
    padding: 0px;
}

#button-guardar {
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    padding-top: 38px;
    display: inline-flex;
    justify-content: end;
    width: 100%;
}

#botonera {
    padding-top: 67px;
    display: flex;
    align-items: center;
    justify-content: end;
}

#botonera button {
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    min-width: 145px;
    height: 27px;
    padding: 7px 10px;
    color: #fff;
    text-align: center;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 475;
    line-height: normal;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    display: flex;
    align-items: center;
    justify-content: center;
}

#button-eliminar {
    padding-right: 16px;
}

.table {
    margin-top: 22px;
    width: 100%;
    flex-shrink: 0;
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.thead-document {
    border-radius: 10px 10px 0px 0px;
    width: 100%;
    height: 40px;
    flex-shrink: 0;
}

.thead-document th {
    background: #006c90;
    color: #fff;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.th-1-1 {
    border-radius: 10px 0px 0px 0px;
    display: flex;
    justify-content: center;
    min-width: 4rem;
}

.th-2-1 {
    min-width: 57rem;
}

.th-3-1 {
    min-width: 5rem;
}

.th-5-1 {
    border-radius: 0px 10px 0px 0px;
    min-width: 5rem;
}

.card {
    background-color: rgba(243, 245, 246, 1);
}
.mr-2 {
    margin-right: 0.5rem !important;
}

tbody tr th {
    color: #99abb4 !important;
    font-size: 0.88rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

@media (min-width: 768px) {
    /* Aplicar display flex solo cuando el ancho sea mayor a 1000px */
    .buttons-filter {
        display: flex;
    }
}
</style>
